// Escape a value for safe use inside a double-quoted HTML attribute.
function escapeWishlistAttr(value) {
    return String(value === null || value === undefined ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function swymCallbackFn(swat) {

    window._swat.fetch(function (data) {

        if (data.length > 0) {
            // empty message should not exist but be safe.
            const emptyMessage = document.querySelector('.empty-message');
            if (emptyMessage) {
                emptyMessage.remove();
            }
            data.forEach(element => {
                fetchProduct(element);
            });
        } else {
            const wishlistWrapper = document.querySelector('.wishlist-page');
            const emptyMessageText = wishlistWrapper.dataset.emptyMessage;
            const emptyMessage = document.createElement('div');
            emptyMessage.classList.add('empty-message');
            emptyMessage.innerHTML = `<h4>${emptyMessageText}</h4>`;
            wishlistWrapper.appendChild(emptyMessage);
        }

        let spinner = document.querySelector('.wishlist-loading-overlay__spinner');
        spinner.classList.add('hidden');
    })
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);

function getProductById(id) {
    return fetch(window.lyUrl(`search/suggest.json?q=id:${id}&resources[type]=product&limit=1`))
        .then(response => response.json())
        .then(response => response.resources.results.products.shift())
        .then((product) => {
            return fetch(window.lyUrl(`products/${product.handle}.js`)).then(response => response.json());
        })
        .catch(e => {
            console.error(e);
        });
}

function fetchProduct(wishlistProduct) {
    // use shopify's native API to get a localised price
    this.getProductById(wishlistProduct.empi).then(data => {

        if (data !== undefined && Array.isArray(data.media) && data.media.length > 0) {
            this.buildWishlist({
                ...data,
                image: data.media[0],
                images: data.media
            },
                wishlistProduct);
        }
    });
}

function buildWishlist(product, wishlist) {

    let wishlistWrapper = document.querySelector('.wishlist-page');
    let variantComparePrice;
    let variantPrice;
    let variantOOS;
    let variantName;

    product.variants.forEach(variant => {
        if (variant.id == wishlist.epi) {
            variantComparePrice = variant.compare_at_price,
                variantPrice = variant.price;
            variantOOS = !variant.available;
            let option1 = variant.option1 ? variant.option1 : '';
            let option2 = variant.option2 ? variant.option2 : '';
            let option3 = variant.option3 ? variant.option3 : '';
            variantName = option1 + ' ' + option2 + ' ' + option3;
        }
    });

    if (variantComparePrice > variantPrice) {
        this.price = `
        <div class="price__sale">
          <span class="visually-hidden visually-hidden--inline">${window.lyT('salePrice', 'Sale price')}</span>
          <span class="price-item price-item--sale price-item--last">
              ${Shopify.formatMoney(variantPrice)}
          </span>
          <span class="visually-hidden visually-hidden--inline">${window.lyT('regularPrice', 'Regular price')}</span>
          <span>
              <s class="price-item price-item--regular">
                  ${Shopify.formatMoney(variantComparePrice)}
              </s>
          </span>    
        </div> `;
    } else {
        this.price = `
        <div class="price__regular">
          <span class="visually-hidden visually-hidden--inline">${variantPrice}</span>
          <span class="price-item price-item--regular">
              ${Shopify.formatMoney(variantPrice)}
          </span>
        </div>`;
    }

    let productColour;
    product.options.forEach(option => {
        if (window.lyIsOption(option.name, 'colour')) productColour = option.values[0]
    });


    this.elementOOS = `
    <div class="oos-notify">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><path stroke="#000" stroke-width="2" d="M7 9h16v12H7z"/><path d="m7 9 8 7 8-7" stroke="#000" stroke-width="2"/></svg>
        <a href="${window.lyUrl(`products/${product.handle}`)}" class="oos-notify__button">
            ${window.lyT('wishlistNotifyMe', 'Notify me')}
        </a>
    </div>
    `;

    this.elementSelect = `
    <wishlist-select class="select">
        <select name="wishlist-select" class="facet-filters__sort select__select caption-large wishlist-dropdown-js" aria-label="${escapeWishlistAttr(window.lyT('wishlistChooseSize', 'Choose a size for [title]', { title: product.title }))}">
            ${product.variants.map(v => `
            <option value="${v.id}" ${v.id == wishlist.epi ? 'selected="selected"' : ''} ${!v.available ? 'disabled="disabled"' : ''}> ${v.title} ${!v.available ? '- SOLD OUT' : ''}</option>
            `).join("\n")}
        </select>
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 7">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.997 3.581 8.588 0 10 1.41 4.996 6.4 0 1.41 1.413 0l3.584 3.581Z" fill="#000"></path>
        </svg>
    </wishlist-select>
    `;

    this.elementQuickAdd = `
     <wishlist-quick-add data-id="${wishlist.epi}">
        <button class="button button--secondary">
            <span>${window.lyT('addToBasket', 'Add to basket')}</span>
        </button>
     </wishlist-quick-add>
     `;

    this.imageOne = product.image ? `
     <img srcset="${product.image.src}&amp;width=165 165w,${product.image.src}&amp;width=360 360w,${product.image.src}&amp;width=533 533w,${product.image.src}&amp;width=720 720w,${product.image.src}&amp;width=940 940w,${product.image.src}&amp;width=1066 1066w,${product.image.src} 1848w" src="${product.image.src}&amp;width=533" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="${product.title}" class="motion-reduce" width="1848" height="2768">
     ` : '';

    this.imageTwo = '';

    if (product.images.length > 1) {
        this.imageTwo = `
        <img srcset="${product.images[1].src}&amp;width=165 165w,${product.images[1].src}&amp;width=360 360w,${product.images[1].src}&amp;width=533 533w,${product.images[1].src}&amp;width=720 720w,${product.images[1].src}&amp;width=940 940w,${product.images[1].src}&amp;width=1066 1066w,${product.images[1].src} 1848w" src="${product.images[1].src}&amp;width=533" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="${product.title}" class="motion-reduce" loading="lazy" width="1848" height="2768">
        `;
    }
    wishlistWrapper.innerHTML += `
        <li class="grid__item">
            <div>
                <div class="card-wrapper underline-links-hover">
                    <div class="card
                        card--standard
                        card--media
                        " style="--ratio-percent: 130%;">
                        <a href="${window.lyUrl(`products/${product.handle}`)}" class="full-unstyled-link">
                        <div class="card__inner color-background-1 ratio" style=" --ratio-percent: 130% ">
                        <div class="card__media">
                            <div class="media media--transparent media--hover-effect">
                            ${this.imageOne}
                            ${this.imageTwo}
                            </div>
                        </div>
                        </a>
                            <div class="wishlist-wrapper card__badge top left">
                                <wishlist-button>
                                    <div class="wishlist-button wishlist-added" data-product-empi="${wishlist.empi}" data-product-epi="${wishlist.epi}" data-product-iu="${wishlist.iu}" data-product-du="${wishlist.du}">
                                    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" class="icon icon-wishlist">
                                        <path d="M13.953 7.074 15 8.094l1.047-1.02.058-.057c.676-.66 2.575-2.517 5.312-2.517 1.947 0 3.432.7 4.44 1.79C26.876 7.395 27.5 9 27.5 10.956c0 1.886-.729 3.804-1.946 5.682-1.215 1.874-2.861 3.62-4.553 5.13a44.703 44.703 0 0 1-6 4.482A44.71 44.71 0 0 1 9 21.768c-1.692-1.51-3.339-3.257-4.554-5.131C3.23 14.759 2.5 12.841 2.5 10.955 2.5 9 3.124 7.394 4.143 6.29 5.15 5.2 6.636 4.5 8.583 4.5c2.74 0 4.64 1.86 5.314 2.519l.056.055Z" stroke="#000" stroke-width="3" stroke-miterlimit="10.275"></path>
                                    </svg>
                                    </div>
                                </wishlist-button>
                            </div>
                        </div>
                        <div class="card__content">
                        <div class="card__information">
                            <h3 class="card__heading h5">
                                <a href="${window.lyUrl(`products/${product.handle}`)}" class="full-unstyled-link">
                                ${product.title}
                                </a>
                            </h3>
                            <div class="card-information">
                                <span class="caption-large light"></span>
                                <div class="card__badge">
                                    ${this.badge != undefined ? this.badge : ''}
                                </div>
                                <div class="price  ${product.variants[0].compare_at_price > product.variants[0].price ? 'price--on-sale' : ''} ">
                                <div class="price__container">
                                    ${this.price}
                                </div>
                                </div>
                                <p class="form__label body__copy--tiny">
                                    ${productColour != undefined ? productColour : ''}
                                </p>
                                ${variantOOS ? this.elementOOS : this.elementSelect}
                                ${variantOOS ? '' : this.elementQuickAdd}
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </li> `;
}
